import * as actions from '@returnmates/client-core/src/constants/actionTypes'
import cognitoErrorMapper from '@returnmates/client-core/src/utils/errorMapper'
import { createAsyncAction } from '@returnmates/client-core/src/utils/reduxUtils'
import validate from '@returnmates/client-core/src/utils/validation/login'
import Button from '@returnmates/ui-core/src/components/Button'
import Eye from '@returnmates/ui-core/src/components/images/icons/eye'
import EyeClose from '@returnmates/ui-core/src/components/images/icons/eyeClose'
import Input from '@returnmates/ui-core/src/components/Input'
import SwaySpinner from '@returnmates/ui-core/src/components/SwaySpinner'
import clsx from 'clsx'
import { FORM_ERROR } from 'final-form'
import { memo, useCallback, useState } from 'react'
import { Field, Form } from 'react-final-form'
import { useDispatch } from 'react-redux'

import useStyles from './styles'

function Login() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false)

  const onSubmit = useCallback(
    async ({ password, email }: { password: string; email: string }) => {
      try {
        setIsLoading(true)
        await createAsyncAction(
          dispatch,
          actions.login.request({ username: email, password, metadata: { isAdmin: 'true' } }),
        )
        setIsLoading(false)
      } catch (err) {
        const { message } = err as Error

        setIsLoading(false)
        return { [FORM_ERROR]: cognitoErrorMapper(message || (err as string)) }
      }
    },
    [dispatch],
  )

  const switchPasswordVisibility = useCallback(() => {
    setIsPasswordVisible(val => !val)
  }, [])

  return (
    <>
      {isLoading ? <SwaySpinner /> : null}
      <div className={classes.main}>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          render={({ handleSubmit, submitError }) => (
            <>
              <div className={classes.formWrapper}>
                <img src="/assets/images/login/swayWilson.png" className={classes.swayWilsonLogo} />
                <p className={classes.title}>Wilson</p>
                <Field name="email">
                  {({ input, meta }) => (
                    <form onSubmit={handleSubmit} className={classes.form}>
                      <Input
                        onChange={input.onChange}
                        value={input.value}
                        error={meta.touched && meta.error}
                        helperText={meta.error}
                        placeholder="Email"
                        className={clsx(classes.emailInput, classes.input)}
                        autoFocus
                      />
                    </form>
                  )}
                </Field>
                <div className={classes.passwordInputWrapper}>
                  <Field name="password">
                    {({ input, meta }) => (
                      <form onSubmit={handleSubmit}>
                        <Input
                          onChange={input.onChange}
                          value={input.value}
                          error={meta.touched && meta.error}
                          helperText={meta.error}
                          placeholder="Password"
                          className={clsx(classes.passwordInput, classes.input)}
                          type={isPasswordVisible ? 'input' : 'password'}
                        />
                      </form>
                    )}
                  </Field>
                  {isPasswordVisible ? (
                    <Eye className={classes.eyeIcon} onClick={switchPasswordVisibility} />
                  ) : (
                    <EyeClose className={classes.eyeIcon} onClick={switchPasswordVisibility} />
                  )}
                </div>
                <Button
                  fullWidth
                  onClick={handleSubmit}
                  label="Sign in"
                  className={classes.button}
                  isLoading={isLoading}
                />
                {submitError ? <p className={classes.error}>{submitError}</p> : null}
                <img src="/assets/images/login/swayLogo.png" className={classes.swayLogo} />
              </div>
            </>
          )}
        />
      </div>
    </>
  )
}

export default memo(Login)
